import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/features';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { OmniLiveAvailabilityFacade } from '@cigna/omni/live-availability-state';
import { MessagingFacade } from '../facade/messaging.facade';
import { CtaListItemData } from '../interfaces';
import { ConversationInterface } from '../interfaces/conversation.interface';

@Component({
  selector: 'cigna-omni-messaging-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniMessagingDataComponent {
  public inputEnabled$ = this.msgFacade.inputEnabled$;
  public disclaimer$ = this.msgFacade.disclaimer$;
  public events$ = this.msgFacade.events$;
  public outroObj$ = this.msgFacade.outro$;
  public conversationType$ = this.msgFacade.conversationType$;
  public minimized$ = this.msgFacade.minimized$;
  public liveChatAvailable$ = this.liveAvailableFacade.liveChatAvailable$;
  public chatCloseHrsMsg$ = this.liveAvailableFacade.chatCloseHrsMsg$;
  public isUnmuted$ = this.omniChatFacade.isUnmuted$;
  public title$ = this.omniChatFacade.headerTitle$;
  public closeSplashScreen$ = this.cnvFacade.closeSplashScreen$;
  public conversation$ = this.cnvFacade.conversation$;
  public shouldEnablePreChatWelcome$ = this.features.featuresEnabled([
    'enableNewPreChatWelcome',
  ]);
  public shouldEnableChat$ = this.features.featuresEnabled([
    'shouldEnableChat',
  ]);
  public isAiBot$ = this.cnvFacade.isAiBot$;
  public screenText = 'Are you sure you want to end this chat?';
  public isHistoryView$ = this.omniChatFacade.isHistory$;
  public useRightNowChat$ = this.features.featuresEnabled(['useRightNowChat']);
  public shouldEnabledBackToPrevious$ =
    this.msgFacade.shouldEnabledBackToPrevious$;
  public replaceBackToPreviousWithEndChat$ =
    this.msgFacade.replaceBackToPreviousWithEndChat$;
  public isUpdatingConversation$ = this.cnvFacade.isUpdatingConversation$;

  userQuestion: string;

  constructor(
    private cnvFacade: OmniConversationsFacade,
    private msgFacade: MessagingFacade,
    private liveAvailableFacade: OmniLiveAvailabilityFacade,
    private omniChatFacade: OmniChatFacade,
    private features: FeatureTogglesFacade,
  ) {}

  public setMessageViewed(messageId: string): void {
    this.cnvFacade.messageViewed(messageId);
  }

  public postCta({
    sourceMessageId,
    value,
    topicId,
    label,
    primaryTopicName,
    _id,
  }: CtaListItemData) {
    this.cnvFacade.postCta(
      sourceMessageId || '',
      value,
      topicId || '',
      label || '',
      _id || '',
      primaryTopicName || '',
    );
  }

  public postMessage(
    message: string,
    conversation: ConversationInterface,
  ): void {
    if ((conversation.state as string) === 'transfer-manual') {
      this.cnvFacade.transferConversation(conversation._id, 'live', message);
    } else {
      this.cnvFacade.postMessage(message);
    }
  }

  public navigateBack(): void {
    this.omniChatFacade.back();
  }

  public keyHandler() {
    this.cnvFacade.onKeyUp();
  }
}
